/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber14Small = createReactComponent("outline", "number-14-small", "IconNumber14Small", [["path", { "d": "M7 10l2 -2v8", "key": "svg-0" }], ["path", { "d": "M13 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M17 8v8", "key": "svg-2" }]]);

export { IconNumber14Small as default };
//# sourceMappingURL=IconNumber14Small.mjs.map
